import router from '../router'
import Vue from 'vue'

export const actions = {
    auth ({commit}, payload) {
        return new Promise((resolve, reject) => {
            commit('setLoading', true);
            commit('clearError');
            commit('clearRegistrationInfo');
            Vue.prototype.$axios.get('/auth', payload)
                .then(response => {
                    commit('setLoading', false);
                    if (response.data.success) {
                        console.log( response.data.data.registrationInfo);
                        commit('setRegistrationInfo', response.data.data.registrationInfo);
                        resolve(response.data)
                    } else {
                        reject(response.data.messages);
                    }
                })
                .catch(error => {
                    commit('setLoading', false);
                    reject( error );
                });
        })
    },
    login({commit}, payload) {
        commit('clearAuth');
        commit('clearUser');
        commit('clearError');

        return new Promise((resolve, reject) => {
            commit('setLoading', true);
            Vue.prototype.$axios.post('/login', payload)
                .then(response => {
                    commit('setLoading', false);
                    if (response.data.success) {
                        commit('setUser', response.data.user);
                        commit('setAuth', true);
                        resolve(response.data)
                    } else {
                        reject(response.data.messages);
                    }
                })
                .catch(error => {
                    // commit('setError', error.message);
                    commit('setLoading', false);
                    commit('clearUser');
                    reject( error );
                });
        })
    },
    performLogout ({commit}) {
        //Vue.prototype.$axios.get('/logout');
        commit('setLoading', false);
        commit('clearError');
        commit('clearUser');
        commit('clearAuth');
        commit('clearRegistrationInfo');
        sessionStorage.clear();

        router.push('/login')
    },
    serverLog (payload) {
        Vue.prototype.$axios.post('/log', payload)
            .then(() => {
            })
    },
    checkIban ({commit}, payload) {
        commit('clearError');
        return new Promise((resolve, reject) => {
            commit('setLoading', true);
            Vue.prototype.$axios.post('/checkIBAN', payload)
                .then(response => {
                    commit('setLoading', false);
                    if (response.data.success) {
                        commit('setRegistrationInfo', response.data.account);
                        resolve(response.data)
                    } else {
                        reject(response.data.messages);
                    }
                })
                .catch(error => {
                    commit('setLoading', false);
                    reject( error );
                });
        })
    },
    checkAuthorization ({commit}, payload) {
        commit('clearError');
        return new Promise((resolve, reject) => {
            commit('setLoading', true);
            Vue.prototype.$axios.post('/checkAuthorization', payload)
                .then(response => {
                    commit('setLoading', false);
                    if (response.data.success) {
                        // commit('setAccountInfo', response.data.account);
                        resolve(response.data)
                    } else {
                        reject(response.data.messages);
                    }
                })
                .catch(error => {
                    commit('setLoading', false);
                    reject( error );
                });
        })
    },
    verifyTaxNumbers ({commit}, payload) {
        commit('clearError');
        return new Promise((resolve, reject) => {
            commit('setLoading', true);
            Vue.prototype.$axios.post('/verifyTaxNumber', payload)
                .then(response => {
                    commit('setLoading', false);
                    if (response.data.success) {
                        resolve(response.data)
                    } else {
                        reject(response.data.messages);
                    }
                })
                .catch(error => {
                    commit('setLoading', false);
                    reject( error );
                });
        })
    },
    registration ({commit}) {
        commit('clearError');
        return new Promise((resolve, reject) => {
            commit('setLoading', true);
            Vue.prototype.$axios.get('/registration')
                .then(response => {
                    commit('setLoading', false);
                    if (response.data.success) {
                        // commit('setAccountInfo', response.data.account);
                        resolve(response.data)
                    } else {
                        reject(response.data.messages);
                    }
                })
                .catch(error => {
                    commit('setLoading', false);
                    reject( error );
                });
        })
    },
    getPdf ({commit}, payload) {
        commit('clearError');
        return new Promise((resolve, reject) => {
            commit('setLoading', true);
            Vue.prototype.$axios.post('/getContractPdf', payload)
                .then(response => {
                    commit('setLoading', false);
                    if (response.data.success) {
                        // commit('setAccountInfo', response.data.account);
                        resolve(response.data)
                    } else {
                        reject(response.data.messages);
                    }
                })
                .catch(error => {
                    commit('setLoading', false);
                    reject( error );
                });
        })
    },
    addLegalOwners ({commit}, payload) {
        commit('clearError');
        return new Promise((resolve, reject) => {
            commit('setLoading', true);
            Vue.prototype.$axios.post('/addLegalOwners', payload)
                .then(response => {
                    commit('setLoading', false);
                    if (response.data.success) {
                        // commit('setAccountInfo', response.data.account);
                        resolve(response.data)
                    } else {
                        reject(response.data.messages);
                    }
                })
                .catch(error => {
                    commit('setLoading', false);
                    reject( error );
                });
        })
    },
    sendInquiry ({commit}, payload) {
        commit('clearError');
        return new Promise((resolve, reject) => {
            commit('setLoading', true);
            Vue.prototype.$axios.post('/sendInquiry', payload)
                .then(response => {
                    commit('setLoading', false);
                    if (response.data.success) {
                        resolve(response.data)
                    } else {
                        reject(response.data.messages);
                    }
                })
                .catch(error => {
                    commit('setLoading', false);
                    reject( error );
                });
        })
    },
};